const bridgeWarGui = process.env.REACT_APP_MODE === 'war'; //false;

const environment: 'audrey' | 'shark' = bridgeWarGui ? 'shark' : process.env.REACT_APP_MODE as 'audrey' | 'shark';

export const gameDataHost = 'https://gamedata.onlinebridgeclub.com';

const emailSupport = 'support@sharkbridge.info'; //'support@betterbridge.com'; //:

const bwar_home = 'https://home.bridgebattle.com';
const bwar_duel = 'https://home.bridgebattle.com/duel';
const bwar_widget = 'https://home.bridgebattle.com/widget';

export { environment, emailSupport, bridgeWarGui, bwar_home, bwar_duel, bwar_widget };
